export enum DateEditorType {
    DateTime = 1,
    Date = 2,
    Time = 3
  }
  